import { directApiInstance } from './httpClient';
import { isPassError } from '../utils/apiErrors';

/**
 * S-38 — cancel a residential invitation: `PUT /invitation/{id}` with `{ status_id: 6 }`, no longer
 * `PATCH /crud/invitation` (the backend refuses status 6 there with 409 use_invitation_endpoint).
 * Headers are the usual ones: the admin's X-Api-Key and the Cognito token as Bearer (httpClient).
 *
 * 200 answers `{ data: [row] }` with `hik_pin: ""` (the Hik pass is revoked in the background).
 * 403: outside the user's scope (the global interceptor shows the server's message).
 * 409: it was already cancelled; the caller refreshes and shows the current state.
 * 409 `pass_expired` (SAM-981): the pass has ended and takes no change, cancelling included. That is not
 * "already cancelled": it is thrown, and the generic toast says why.
 */
export type CancelInvitationOutcome = 'cancelled' | 'already-cancelled';

export const cancelInvitation = async (id: string | number): Promise<CancelInvitationOutcome> => {
  try {
    await directApiInstance({ url: `/invitation/${id}`, method: 'PUT', data: { status_id: 6 } });
    return 'cancelled';
  } catch (err: any) {
    if (err?.response?.status === 409 && !isPassError(err)) return 'already-cancelled';
    throw err;
  }
};
